import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store/index.js'
import { ThemeProvider } from './context/ThemeContext.jsx'
import { AuthProvider } from './context/auth.jsx'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { CartProvider } from './context/CartContext.jsx'
import { ToastProvider } from './context/Toast/ToastContext.jsx'
import ToastContainer from './context/Toast/ToastContainer.jsx'
import { HelmetProvider } from "react-helmet-async"
import { setupAxiosInterceptors } from './api/setupInterceptors.js'

// Boot axios interceptors once before any render
setupAxiosInterceptors();

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID;

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <AuthProvider>
      <HelmetProvider>
        <BrowserRouter>
          <ToastProvider>
            <ToastContainer />
            <React.StrictMode>
              <ThemeProvider>
                <GoogleOAuthProvider clientId={googleClientId}>
                  <CartProvider>
                    <App />
                  </CartProvider>
                </GoogleOAuthProvider>
              </ThemeProvider>
            </React.StrictMode>
          </ToastProvider>
        </BrowserRouter>
      </HelmetProvider>
    </AuthProvider>
  </Provider>
)
